import { render, staticRenderFns } from "./Habits.vue?vue&type=template&id=17fe637e&scoped=true&"
import script from "./Habits.vue?vue&type=script&lang=js&"
export * from "./Habits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe637e",
  null
  
)

export default component.exports